module.exports = __webpack_public_path__ + "assets/img/FAVORITOS.cc891a05.svg";